export const datatableMapContainer = {
  height: '100%',
  zIndex: 0,
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
};
